import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, map } from 'rxjs';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { Rights } from 'src/app/models/enums/rights';
import { FolderState } from 'src/app/models/folder-state';
import { ISortable } from 'src/app/models/interfaces/sortable.interface';
import { FoldersStatesService } from 'src/app/services/folders-states.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-folder-states-list',
    templateUrl: './folder-states-list.component.html',
    styleUrls: ['./folder-states-list.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class FolderStatesListComponent extends DefaultListComponent<FolderState> implements OnInit, AfterViewInit {
    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param foldersStatesService : Service de gestion des états de dossier.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        private foldersStatesService: FoldersStatesService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        // Specifie des colonnes en fonction des droits utilisateurs
        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 5, true),
                new ColumnDefinition('name', 'Name', ColumnType.Text, FilterType.Text, 2, 80, true),
                new ColumnDefinition('order', 'Ordre', ColumnType.Numeric, FilterType.Numeric, 3, 10, true),
            ];
        } else {
            this.tableConfig = [
                new ColumnDefinition('name', 'Name', ColumnType.Text, FilterType.Text, 2, 85, true),
                new ColumnDefinition('order', 'Ordre', ColumnType.Numeric, FilterType.Numeric, 3, 10, true),
            ];
        }

        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.FolderStateEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.FolderStateDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.dataSource = new AdvancedDataSource(null, this.foldersStatesService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('order', 'asc'));
    }

    ngAfterViewInit() {
        this.gridView.getSortableItemsFunction = this.getSortablesItems.bind(this);
        // bind(this) permet de specifier que le mot clé this utilisé dans la fonction getSortablesItems utilisera l'instance de FolderStatesList et non pas l'instance de la gridview qui appelle la fonction.
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<FolderState>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer l'état de dossier '${event.context.name}'.`, event.context);
        }
    }

    public onItemsSorted(event: ISortable[]) {
        this.itemsSorted.emit(event);
    }

    protected getSortablesItems(item: FolderState): Observable<FolderState[]> {
        return this.foldersStatesService.List(null, null, null, null).pipe(
            map((x) => {
                x.value.sort((a, b) => {
                    return a.order < b.order ? -1 : 1;
                });
                return x.value;
            })
        );
    }
}
